import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ChienNoir from '../chiennoir/Home';

function Router() {
  return (
    <Routes>
      <Route exact path="/chiennoir/home" element={<ChienNoir />} />
    </Routes>
  );
}

export default Router;
